<ng-container *ngIf="cardData$ | async as data">
  <div class="flex flex-col">
    <div class="flex flex-col" *ngIf="data.vehicle">

      <div class="flex flex-row place-content-between place-items-center w-full">
        <div class="flex flex-col">
          <span *ngIf="data?.vehicleReport?.equityValue && data.vehicleReport.equityValue > 0"> - In Equity
            {{data.vehicleReport.equityValue | currency}}</span>
          <div class="flex place-content-start place-items-cener">
            <span class="primary-bullet">·</span>
            <span data-cy='currentMileage'>Mileage last logged at {{data.vehicle.currentMileage}}{{mileageLabel}}</span>
          </div>
          <div class="flex place-content-start place-items-center">
            <span class="primary-bullet">·</span>
            <span *ngIf="data.warrantyInfo.regularWarranty;else noRegularWarranty"
              data-cy='warrantyInfo'>{{data.warrantyInfo.regularWarranty.warrantyTerm}}
              Months/{{data.warrantyInfo.regularWarranty.warrantyMileage}}{{mileageLabel}} Basic Warranty -
              {{basicWarrantyStatus}}
            </span>
            <ng-template #noRegularWarranty>
              <span data-cy='noRegularWarranty'>No regular warranty found</span>
            </ng-template>
          </div>
          <div class="flex place-content-start place-items-center">
            <span class="primary-bullet">·</span>
            <span *ngIf="data.warrantyInfo.extendedWarranty;else noExtendedWarranty"
              data-cy='extendedWarranty'>{{data.warrantyInfo.extendedWarranty.extendedWarrantyPlanDescription}}
              -
              {{data.warrantyInfo.extendedWarranty.conversionWarrantyDescription ?
              data.warrantyInfo.extendedWarranty.conversionWarrantyDescription : ''}}
              Expires on {{data.warrantyInfo.extendedWarranty.expiryDate | moment: 'MMM DD, YYYY'}} or
              {{data.warrantyInfo.extendedWarranty.expiryMileage}}{{mileageLabel}}</span>
            <ng-template #noExtendedWarranty>
              <span data-cy='noExtendedWarranty'>No extended warranty found</span>
            </ng-template>
          </div>
        </div>
        <div>
          <img *ngIf="vehicleImage; else noImageFound" class="w-auto h-14" [src]="vehicleImage">
          <ng-template #noImageFound>
            No vehicle image found.
          </ng-template>
        </div>
      </div>
      <div *ngIf="data.warrantyInfo.otherExtendedWarranties.length > 0;else noOtherExtendedWarranties">
        <div class="flex place-content-start place-items-center">
          <span class="primary-bullet">·</span><span>Other extended warranty plans found:</span>
        </div>
        <ul data-cy='otherExtendedWarranty'>
          <li *ngFor="let otherWarranty of data.warrantyInfo.otherExtendedWarranties;">
            {{otherWarranty.planDescription}}
            that expires
            on
            {{otherWarranty.expiryDate | moment: 'MMM DD, YYYY'}} or at
            {{otherWarranty.expiryMileage}}{{mileageLabel}}
          </li>
        </ul>
      </div>
      <ng-template #noOtherExtendedWarranties>
        <div class="flex place-content-start place-items-center">
          <span class="primary-bullet">·</span>
          <span data-cy='noOtherExtendedWarranty'>No additional extended warranties found</span>
        </div>
      </ng-template>
    </div>
    <div class="flex place-content-end place-items-center pt-2">
      <div class="relative mr-3" *ngIf="serviceLaneFacade.allNotes$ | async as notes">
        <span class="absolute w-4 h-4 rounded-full border-2 border-white bg-blue-500 -right-1 -top-1"
          style="z-index: 4;"
          *ngIf="(notes.customerNotes && notes.customerNotes?.notes?.split('\r').length > 0)  || (notes.vehicleNotes && notes.vehicleNotes?.notes?.split('\r').length > 0)">
        </span>
        <button mat-flat-button color="primary" class="text-xs pt-2 pb-2 mb-3"
          (click)="openNotesDialog(associate.id, data.vehicle.id)">Notes</button>
      </div>

      <button mat-flat-button color="primary" class="text-xs pt-2 pb-2 mb-3 mr-3" (click)="openMediaDialog()">Media
        Gallery</button>
      <!-- STAND ALONE MENU -->
      <!-- <button mat-flat-button color="primary" class="media-gallery-button mr-4" (click)="visitMenu()">Menu</button> -->
      <!-- GM -->
      <!-- <button mat-flat-button color="primary" class="media-gallery-button mr-4" [routerLink]="['./dashboard']"
        [queryParams]="{oemrtId: '1', vehicleVin: '3GNBACDV3AS600994', odometerIn: '157000', employeeId: associate.id, oem: 'GM', vehicleId: vehicleId}">Dashboard</button> -->
    </div>
  </div>
</ng-container>